import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OpenAppCallbackConfig } from '../models/open-app/open-app-callback-config.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class OmOpenAppCallBackConfigService extends RequestService<OpenAppCallbackConfig> {
  static PATH = '/om/open/app/callback/config';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(
      httpClient,
      OmOpenAppCallBackConfigService.PATH,
      globalService.debugUrl
    );
  }
}
